import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { ICommitteeMember } from "src/domain/entities"
import { committeeMemberDeleteService } from "src/domain/services/committeeMember/committeeMemberDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	committeeMember: ICommitteeMember
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const CommitteeMemberDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	committeeMember,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleCommitteeMemberDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await committeeMemberDeleteService({ id: committeeMember.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [committeeMember, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete CommitteeMember: ${committeeMember.profile?.id}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleCommitteeMemberDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
